import React, { useEffect, useState } from 'react'
import { Contents, Left, Right, Wrapper } from './styled'

import OrderPartyDesc from './OrderPartyDesc'
import OrderPartyAction from './OrderPartyAction'
import OrderPartyModal from './OrderPartyModal'
import slugify from 'utils/slugify'

function OrderParty({
  detachParty,
  isAuthenticated,
  isLeader,
  isMember,
  joinOrderParty,
  notify,
  onLeave,
  party,
  venueId,
  match,
  history,
}) {
  const [isLoginModalOpen, setModalState] = useState(!isAuthenticated && party)

  useEffect(() => {
    setModalState(!isAuthenticated && party)
  }, [isAuthenticated])

  useEffect(() => {
    if (isAuthenticated && party) {
      // user already placed an order
      if (party.memberStatus === 'ORDER_PLACED') {
        notify({
          type: 'success',
          message: 'You already placed an order to this party.',
        })
        return
      }
      // join the party
      if (!party.memberStatus) {
        joinOrderParty({ orderPartyId: party.id, venueId })
        return
      }
    }
  }, [isAuthenticated, party])

  const handleModalClose = () => setModalState(false)

  const handleRequestLogin = () => setModalState(true)

  const handleLeave = () => {
    if (match.path === '/order/:id/status') {
      history.replace(`/restaurant/${venueId}/${slugify(party.vendorName)}`)
      detachParty(venueId)
      return Promise.resolve()
    } else {
      return onLeave()
    }
  }

  if (!party) return null

  return (
    <Wrapper>
      <Contents>
        <Left>
          <OrderPartyDesc
            description={party.description}
            leaderCustomerImage={party.leaderCustomerImage}
            name={party.name}
          />
        </Left>
        <Right>
          <OrderPartyAction
            isLoggedIn={isAuthenticated}
            isLeader={isLeader && isAuthenticated}
            isMember={isMember && isAuthenticated}
            onRequestLogin={handleRequestLogin}
            onLeave={handleLeave}
            shareLink={party.inviteLink}
          />
        </Right>
      </Contents>
      <OrderPartyModal
        onRequestClose={handleModalClose}
        isOpen={!!isLoginModalOpen}
        {...party}
      />
    </Wrapper>
  )
}

export default OrderParty
